module.exports = __webpack_public_path__ + "img/slide1-tronic-else.41defcb2.png";